import { Dispatch } from "redux";

import { loadAndTrack } from "redux-request-loading";
import axios from "axios";

import { Payload } from "@neworbit/redux-helpers";

import Utils from "@teamprevent/common/utils";
import { WorkGroupDetailModel } from "@teamprevent/common/workGroup/model";

import * as actions from "./actiontypes";
import * as models from "./model";
import { workGroupApi } from "./workGroupApi";

import { push } from "redux-little-router";

export type WorkGroupAction =
      ({ type: typeof actions.LOAD_WORKGROUPS_SUCCESS } & Payload<WorkGroupDetailModel[]>)
    | ({ type: typeof actions.CREATE_WORKGROUP_SUCCESS } & Payload<WorkGroupDetailModel>)
    | ({ type: typeof actions.LOAD_WORKGROUP_DETAIL_SUCCESS } & Payload<WorkGroupDetailModel>)
    | ({ type: typeof actions.SAVE_WORKGROUP_SUCCESS } & Payload<WorkGroupDetailModel>)
    | ({ type: typeof actions.DELETE_WORKGROUP_SUCCESS } & Payload<any>);

export const loadWorkGroupsSuccess = (payload: WorkGroupDetailModel[]): WorkGroupAction => ({
    payload,
    type: actions.LOAD_WORKGROUPS_SUCCESS
});

export const createWorkGroupSuccess = (payload: WorkGroupDetailModel): WorkGroupAction => ({
    payload,
    type: actions.CREATE_WORKGROUP_SUCCESS
});

export const saveWorkGroupSuccess = (payload: WorkGroupDetailModel): WorkGroupAction => ({
    payload,
    type: actions.SAVE_WORKGROUP_SUCCESS
});

export const deleteWorkGroupSuccess = (id: any): WorkGroupAction => ({
    payload: id,
    type: actions.DELETE_WORKGROUP_SUCCESS
});

export function createWorkGroup(customerId: string, workGroup: models.WorkGroupCreateModel, path: string) {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(dispatch, actions.CREATE_WORKGROUP, workGroupApi.create(customerId, workGroup));
        const result = Utils.CheckResponse(response);

        if (response.success && result) {
            dispatch(createWorkGroupSuccess(result));
            dispatch(push(`${path}/${result.id}`, {}));
        }
    };
}

export function saveWorkGroup(customerId: string, workGroup: models.WorkGroupEditModel, path?: string) {
    return async (dispatch: Dispatch) => {
        const response = await loadAndTrack(dispatch, actions.SAVE_WORKGROUP, workGroupApi.save(customerId, workGroup));
        const result = Utils.CheckResponse(response);

        if (response.success && result) {
            dispatch(saveWorkGroupSuccess(result));
            if (path !== undefined) {
                dispatch(push(`${path}/${result.id}`, {}));
            }
        }
    };
}

export function deleteWorkGroup(customerId: string, workGroupId: string, path: string) {
    return async (dispatch: Dispatch) => {
        await loadAndTrack(dispatch, actions.DELETE_WORKGROUP, workGroupApi.delete(customerId, workGroupId));
        dispatch(deleteWorkGroupSuccess(workGroupId));
        dispatch(push(`${path}`, {}));
    };
}

export function loadWorkGroups({ customerId }: { customerId: string }) {
    return async (dispatch: Dispatch) => {
        try {
            const result = await loadAndTrack(dispatch, actions.LOAD_WORKGROUP, workGroupApi.getAll(customerId));
            dispatch(loadWorkGroupsSuccess(result));
        } catch (ex) {
            if (!(ex instanceof axios.Cancel)) { // eslint-disable-line import/no-named-as-default-member
                throw ex;
            }
        }
    };
}

export const loadWorkGroupDetailSuccess = (workGroup: WorkGroupDetailModel) => ({
    payload: workGroup,
    type: actions.LOAD_WORKGROUP_DETAIL_SUCCESS
});

export function loadWorkGroupDetail({ customerId, workGroupId }: { customerId: string; workGroupId: string }) {
    return async (dispatch: Dispatch) => {
        const result = await loadAndTrack(dispatch, actions.LOAD_WORKGROUP_DETAILS, workGroupApi.detail(customerId, workGroupId));
        dispatch(loadWorkGroupDetailSuccess(result));
    };
}
